(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/brands/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/ui/brands/assets/javascripts/helpers/handlebars-helpers.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


(function (svs) {
  'use strict';

  var brands;

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    brands = require('../brands-hashmap.es6');
    registerHelpers(require('hbs'));
  } else {
    brands = svs.ui.brands;
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('ui_brands_getBrand', function (_brand, _size) {
      var options = arguments[arguments.length - 1],
          obj = brands.getBrand(_brand, _size);
      return options.fn(this, {
        data: options.data,
        blockParams: [obj.brand, obj.svg]
      });
    });
    hbs.registerHelper('ui_brands_getEmblem', function () {
      return brands.getEmblem();
    });
  }
})(svs);
 })(window);